import classNames from 'classnames';
import styles from '@components/jobForm/jobForm.module.scss';
import stylesJob from '@components/jobIndexCard/JobForm.module.scss';
import { apiUrls } from '@constants/apiurls';
import { useState } from 'react';
import { useEffect } from 'react';
import { JobForm } from '@components/jobForm/jobForm';
import { Heading } from '@components/heading/heading';
import { Header } from '@components/header/header';
import clients from '@redux/modules/clients';
import yupSchemaService from '@services/yupSchemaService';
import dataService from 'services/dataService';
import { fetchAutoCompleteData } from '@services/autoCompleteService';
import jobs from '@redux/modules/jobs';
import _ from 'lodash';
import toast from 'react-hot-toast';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { routesPath } from 'constants/routesPath';
import { Spinner } from '@components/loader/loader';
import dayjs from 'dayjs';
import { JobHeader } from '@components/jobHeader/jobHeader';
import { useJobConatiner } from '../jobContainer/jobContainer';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { handleJobData, updateWizardStep } from '../../redux/common/commonSlice';
import { isEmpty } from 'lodash';
import { FormProvider } from 'react-hook-form';

export const JobsFormContainer = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const { form } = useJobConatiner();
  const jobsData = useSelector((state) => state.commonReducer.jobData);

  const [state, setState] = useState({
    colors: [],
    employmentTypes: [],
    positionLevels: [],
    preferredQualifications: [],
    languages: [],
    membershipGrades: [],
    images: jobsData?.state?.images || [],
    durations: [],
    clientData: null,
    city: jobsData?.state?.city || '',
    state: jobsData?.state?.city || '',
    country_id: jobsData?.state?.country_id || '',

    loading: false,
  });

  const {
    data: clientsList,
    isLoading: isLoadingClient,
    error: errorClient,
    isSuccess: successClient,
  } = clients.list().useClientslistQuery({ params: '', extendedPath: apiUrls.getClientListing() });

  // Get job data from parent JobContainer via Redux or props instead of fetching again
  const jobDataFromParent = useSelector((state) => state.commonReducer.jobData);

  const [updateJob, jobUpdateData] = jobs.form().useJobupdateMutation();

  const [createJob, createJobData] = jobs.form().useJobcreateMutation();

  useEffect(() => {
    getInitailData();
    dispatch(
      updateWizardStep({
        step: 0,
      }),
    );
    
    // Check for duplicate job data in localStorage
    const duplicateData = localStorage.getItem('duplicateJobData');
    if (duplicateData && !params.jobId) {
      try {
        const jobToDuplicate = JSON.parse(duplicateData);
        
        console.log('Duplicating job:', jobToDuplicate);
        
        // Ensure we have the required fields
        if (!jobToDuplicate.client_id && !jobToDuplicate.client?.id) {
          toast.error('Cannot duplicate job: Missing client information');
          localStorage.removeItem('duplicateJobData');
          return;
        }
        
        // Parse the data for the form
        const parsedData = dataService.parseFormDataForJobEdit(jobToDuplicate);
        
        // Explicitly ensure critical fields are preserved
        parsedData.description = jobToDuplicate.description || jobToDuplicate.job?.description || '';
        parsedData.title = jobToDuplicate.title || '';
        parsedData.client_id = jobToDuplicate.client_id || jobToDuplicate.client?.id || null;
        
        // Ensure dates are set
        if (!parsedData.publish_date) {
          parsedData.publish_date = dayjs().format('DD-MMM-YYYY');
        }
        if (!parsedData.expiry_date) {
          parsedData.expiry_date = dayjs().add(3, 'month').format('DD-MMM-YYYY');
        }
        
        // Set form values with the duplicated data
        setTimeout(() => {
          form.reset(parsedData);
          
          // Explicitly set critical fields to ensure they're in the form
          setTimeout(() => {
            form.setValue('description', parsedData.description, { 
              shouldValidate: true,
              shouldDirty: false 
            });
            form.setValue('title', parsedData.title, { 
              shouldValidate: true,
              shouldDirty: false 
            });
            form.setValue('client_id', parsedData.client_id, { 
              shouldValidate: true, 
              shouldDirty: false 
            });
            
            // For the contentEditable description field, also update the DOM directly
            const descElement = document.getElementById('job-description');
            if (descElement && parsedData.description) {
              descElement.innerHTML = parsedData.description;
              console.log('📝 Set description innerHTML:', parsedData.description.substring(0, 50));
            }
            
            // Trigger form validation to ensure all fields are marked as valid
            form.trigger(['description', 'title', 'client_id']);
          }, 50);
          
          // Update local state with images and location
          setState(prev => ({
            ...prev,
            images: jobToDuplicate.job_images || [],
            city: jobToDuplicate.city || '',
            country_id: jobToDuplicate.country_id || '',
          }));
          
          // Also dispatch to Redux so JobContainer can access it
          dispatch(handleJobData({ 
            state: {
              images: jobToDuplicate.job_images || [],
              city: jobToDuplicate.city || '',
              country_id: jobToDuplicate.country_id || '',
            },
            formValues: parsedData 
          }));
        }, 500);
        
        // Clear the localStorage after a delay to ensure form is populated
        setTimeout(() => {
          localStorage.removeItem('duplicateJobData');
        }, 1000);
        
        toast.success('Job duplicated! Fill in any missing fields and save as draft or publish.');
      } catch (error) {
        console.error('Error loading duplicate job data:', error);
        toast.error('Failed to load duplicate job data');
        localStorage.removeItem('duplicateJobData');
      }
    }
  }, []);

  // Note: Job data fetching and form population is now handled by parent JobContainer
  // to avoid conflicts and glitching when editing jobs
  
  // Update local state when jobsData from Redux changes (e.g., when editing a job)
  useEffect(() => {
    if (jobsData?.state) {
      setState((prevState) => ({
        ...prevState,
        images: jobsData.state.images || prevState.images,
        city: jobsData.state.city || prevState.city,
        country_id: jobsData.state.country_id || prevState.country_id,
      }));
    }
  }, [jobsData]);

  useEffect(() => {
    if (jobUpdateData.isSuccess) {
      toast.success('Job Updated Successfully!');
      navigate(routesPath.jobs, { replace: false });
    }
    if (jobUpdateData.isError) {
      toast.error('Failed To Update Job!');
    }
  }, [jobUpdateData]);

  useEffect(() => {
    if (clientsList) {
      let result = dataService.autoCompletionParser('clients', _.cloneDeep(clientsList?.data));
      setState((prevState) => ({ ...prevState, clientData: result }));
    }
  }, [clientsList]);

  const getInitailData = async () => {
    const initailDataList = [
      { url: apiUrls.getColors() },
      { url: apiUrls.getEmploymentTypes() },
      { url: apiUrls.getPositionLevels() },
      { url: apiUrls.getQualifications() },
      { type: 'language', url: apiUrls.getLanguages() },
      { url: apiUrls.getMemberShipGrades() },
      { type: 'duration', url: apiUrls.getJobDuration() },
    ];
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const promises = initailDataList.map((data) => fetchAutoCompleteData(data.type, data.url));
      const response = await Promise.all(promises);

      setState((prevState) => ({
        ...prevState,
        colors: response[0],
        employmentTypes: response[1],
        positionLevels: response[2],
        preferredQualifications: response[3],
        languages: response[4],
        membershipGrades: response[5],
        durations: response[6],
        loading: false
      }));
      
      // Note: Form population is handled by parent JobContainer
      // Just restore any localStorage form values if available
      const savedFormValues = localStorage.getItem('jobFormVlaues');
      if (savedFormValues && !params.jobId) {
        form.reset(JSON.parse(savedFormValues));
      }
      
      dispatch(handleJobData({ state: state }));
    } catch (err) {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  };


  useEffect(() => {
    if (createJobData?.isSuccess) {
      toast.success('Job Successfully Created!');
      navigate(routesPath.jobs, { replace: false });
    }
    if (createJobData?.error) {
      toast.error('Failed To Post Job!');
    }
  }, [createJobData]);

  const getRedner = useCallback(() => {
    return (
      <div>
        <div className={styles.p20}>
          <div className={classNames(styles.sectionLabel)}>
            <Heading size="large">{'Tell us about your job'}</Heading>
          </div>
        </div>
        {state.loading ? (
          <div className="text-center">
            <Spinner height="150" width="150" />
          </div>
        ) : (
          <div className={classNames('px-3', 'px-xs-0')}>
            <FormProvider {...form}>
              <JobForm
                colorValue={state?.colors}
                acronymValue={state?.acronymValue}
                colors={state?.colors}
                initialValues={state}
                clients={state?.clientData}
                clientValue={jobDataFromParent?.job?.client_id || jobsData?.job?.client_id}
                employmentTypes={state?.employmentTypes}
                positionLevels={state.positionLevels}
                state={state}
                yupSchema={yupSchemaService.jobCreationSchema()}
                jobData={jobDataFromParent?.job || jobsData?.job}
                preferredQualifications={state.preferredQualifications}
                languageOptions={state.languages}
                membershipGrades={state.membershipGrades}
                setState={setState}
                isEditing={params.jobId}
                durations={state.durations}
                loading={jobUpdateData?.isLoading || createJobData?.isLoading}
              />
            </FormProvider>
          </div>
        )}
      </div>
    );
  }, [state, form.getValues(), params?.jobId, createJobData]);

  return getRedner();
};
